export const KEY_PICKS = [
  '2006+CHAPTER+46:::::',
  '2000+CHAPTER+8:::::',
  '1986+CHAPTER+45:::::'
]

export const EMPLOYMENT_LEGISLATION_KEY_PICKS = [
  '1996+CHAPTER+18:::::',
  '2010+CHAPTER+15:::::',
  '2006+No.+246:::::'
]
